import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Dropdown,
  DropdownItem,
  getColor,
  Icons,
  Modal,
  Tooltip,
  Typography,
  useToast,
} from "fds";
import "./index.scss";
import currentUrlUtils from "../../shared/utils/currentUrlUtils";
import useDocumentStore from "../../redux/dispatcher/useDocumentStore";
import utilsDocs from "../../shared/utils/docs";
import { getUserInfoFromLocalStorage } from "../../shared/utils/auth";
import { LoginDto } from "../../types/auth";
import utilsCommon from "../../shared/utils/common";
import {
  DocDetailDto,
  MenuListType,
  WrapsodySyncInfoResponse,
} from "../../types/files";
import PreviewAside from "./PreviewAside";
import { useNavigate } from "react-router-dom";
import docApi from "../../redux/api/DocApi";
import useStartDownload from "../../shared/hooks/useStartDownload";
import ChangeFileAuthModal from "../../components/More/ChangeFileAuthModal";
import {
  doDeleteDocument,
  doUnauthDocDownload,
  handleCopyLink,
  handleDocDownload,
} from "../../shared/utils/api";
import IframeComm from "react-iframe-comm";
import dayjs from "dayjs";
import { nanoid } from "@reduxjs/toolkit";
import { t } from "i18next";
import ChangeWorkgroupFileAuthModal from "../../components/More/ChangeWorkgroupFileAuthModal";

const Preview = () => {
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);
  const myId = loginDto?.userInfo?.userId ?? "";
  /** Hook 정리 */
  const {
    documentState,
    getContentDetail,
    getContentDownload,
    getDocUsingByWebIncludeToken,
    getDocDecryptDownload,
    getDocDelete,
  } = useDocumentStore();
  const startDownload = useStartDownload();
  const navigate = useNavigate();
  const toast = useToast();
  const { permission, workgroupId, syncId, revisionNo, token, startTab } =
    currentUrlUtils.getAllFirstQuery();

  // 더보기 메뉴 표시 리스트
  let menus = [
    {
      key: "auth",
      resource: t("file.action.auth"),
      icon: <Icons variant="line" label="access" />,
      onClick: () => changeModalType("CHANGE_FILE_AUTH"),
    },
    {
      key: "unAuthDownload",
      resource: t("file.action.decryptedDownload"),
      icon: <Icons variant="line" label="unlock" />,
      onClick: () =>
        docInfo?.documentInfo &&
        doUnauthDocDownload(
          docInfo?.documentInfo,
          toast,
          getDocDecryptDownload,
          startDownload
        ),
    },
    {
      key: "divider",
    },
    {
      key: "delete",
      resource: t("common.delete"),
      icon: <Icons variant="line" label="delete" />,
      onClick: () => changeModalType("CONFIRM_DELETE"),
    },
  ] as {
    key: MenuListType;
    resource: string;
    icon: React.ReactNode;
    onClick?: () => void;
  }[];

  /** State 정리 */
  const [modalType, changeModalType] = useState<
    "CLOSE" | "CONFIRM_DELETE" | "CHANGE_FILE_AUTH"
  >("CLOSE"); // extraModal 열림 여부  : CONFIRM_DELETE:파일삭제확인, CHANGE_FILE_AUTH: 파일 사용 권한
  const [docInfo, changeDocInfo] = useState<DocDetailDto | undefined>(); // 문서 정보
  const [accessUrl, changeAccessUrl] = useState<String | undefined>(undefined); // 문서 링크
  const [syncInfo, changeSyncInfo] = useState<
    WrapsodySyncInfoResponse | undefined
  >(); // 파일 정보
  const [isClient, setIsClient] = useState(false); // 클라이언트에서 열었는지 여부
  const [activeBtnType, changeActiveBtnType] = useState<
    "comment" | "detail" | "aiChat" | "CLOSE"
  >(startTab === "comment" ? startTab : "CLOSE"); // 우측 탭=> comment:의견, detail:상세정보, aiChat: K-ASSISTANT
  const screenWatermark = utilsCommon.convertWatermark(
    loginDto?.userInfo.userName,
    loginDto?.userInfo.userId,
    docInfo?.documentInfo?.contentName !== undefined
      ? docInfo?.documentInfo?.contentName.concat(
          "(",
          docInfo?.documentInfo?.revisionNo.toString(),
          ")"
        )
      : "test.xlsx",
    utilsCommon.renderShortDateFormat(dayjs().valueOf()),
    utilsCommon.renderDateFormat(dayjs().valueOf()),
    loginDto?.ecoUserInfo.remoteAddr,
    loginDto?.ecoCommonConfig.watermarkPattern
  ); // 스크린워터마크 정보

  /** useEffect 정리 */
  useEffect(() => {
    if (!syncId || !permission) return;
    checkPermissionByDetail();
    setIsClient(window.location.search.includes("true"));
  }, [syncId]);
  useEffect(() => {
    changeDocInfo(documentState.contentAsideDetail);
  }, [documentState.contentAsideDetail]);
  // 파일 웹 편집을 위한 useEffect
  useEffect(() => {
    window.addEventListener("beforeunload", end);
    window.addEventListener("load", start);
    return () => {
      window.removeEventListener("beforeunload", end);
      window.removeEventListener("load", start);
    };
  }, []);
  /** 함수 정리 */
  /** 웹 편집 시작 */
  const start = (e: any) => {
    let xFasooActionParam = {} as any;
    window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value): any {
        xFasooActionParam[key] = decodeURIComponent(value);
      }
    );

    if (
      xFasooActionParam["permission"] !== null &&
      xFasooActionParam["permission"] !== undefined &&
      xFasooActionParam["permission"] === "edit"
    ) {
      const xFasooSignature = "Fasoo";
      const xFasooMessage = "documents.previews.completedWebRevise";
      const xFasooMessageParam = [] as string[];
      const xFasooAction = "startWebEdit";

      const fasooMessage = {
        xFasooSignature,
        xFasooMessage,
        xFasooMessageParam,
        xFasooAction,
        xFasooActionParam,
      };
      window.opener?.postMessage(fasooMessage, window.location.origin);
    }
  };
  /** 웹 편집 종료 */
  const end = (e: any) => {
    let xFasooActionParam = {} as any;
    window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value): any {
        xFasooActionParam[key] = decodeURIComponent(value);
      }
    );

    if (
      xFasooActionParam["permission"] !== null &&
      xFasooActionParam["permission"] !== undefined &&
      xFasooActionParam["permission"] === "edit"
    ) {
      const xFasooSignature = "Fasoo";
      const xFasooMessage = "documents.previews.completedWebRevise";
      const xFasooMessageParam = [] as string[];
      const xFasooAction = "endWebEdit";

      const fasooMessage = {
        xFasooSignature,
        xFasooMessage,
        xFasooMessageParam,
        xFasooAction,
        xFasooActionParam,
      };
      window.opener?.postMessage(fasooMessage, window.location.origin);
    }
  };
  /** 문서 처음 열 경우, 권한 판단을 위한 함수 */
  const checkPermissionByDetail = async () => {
    if (!syncId) return;
    let resp: any = await getContentDetail({
      workgroupId: workgroupId ?? "DUMMYID",
      syncId: syncId ?? "",
      type: "aside",
    });
    /** ERROR: 내 권한이 없을 경우, 에러 */
    if (!resp?.payload?.documentInfo?.myPolicy?.policy) {
      window.opener
        ? window.close()
        : navigate(`${process.env.PUBLIC_URL}/home`);
    } else if (!resp.payload?.documentInfo?.myPolicy?.policy.webView) {
      alert(t("file.alert.noWebviewAllow"));
      window.close();
      return;
    }
    let resp1: any = await getDocUsingByWebIncludeToken({
      permission: permission ?? "view",
      workgroupId: resp.payload?.documentInfo?.workgroup?.workgroupId,
      syncId,
      revisionNo: revisionNo ?? "0",
      token: token ? token : "",
    });
    if (resp1.error) {
      alert(resp1.error.message);
      window.close();
    } else if (resp1.payload.accessUrl) {
      changeAccessUrl(resp1.payload.accessUrl);
    } else {
      alert(t("common.alert.serverError"));
      window.close();
    }
    changeActiveBtnType(startTab === "comment" ? startTab : "CLOSE");
    docApi
      .getDocSyncInfo({
        workgroupId: workgroupId ?? "NONEWORKGROUP",
        syncId,
      })
      .then((resp) => changeSyncInfo(resp));
  };
  /** 웹 리비전 권한 판단 */
  const checkIfDocRevision = () => {
    return (
      syncInfo &&
      docInfo &&
      syncInfo.status === "N" &&
      syncInfo.authType === "R" &&
      syncInfo.checkoutUser.userId === "" &&
      permission === "view" &&
      utilsCommon.checkExtensionAvailable(
        docInfo?.documentInfo?.contentName,
        "webRevisionExtensions"
      )
    );
  };
  /** UI: 웹 편집 아이콘 리소스 */
  const renderOfficeType = () => {
    const fileName = docInfo?.documentInfo?.contentName;
    const fileType = fileName
      ? fileName.substring(fileName.lastIndexOf(".") + 1)
      : "";

    if (["docx", "doc"].includes(fileType)) {
      return t("file.onlineOfficeCheckout", { office: "Word Online" });
    } else if (["pptx", "ppt"].includes(fileType)) {
      return t("file.onlineOfficeCheckout", { office: "PowerPoint Online" });
    } else if (["xlsx", "xls"].includes(fileType)) {
      return t("file.onlineOfficeCheckout", { office: "Excel Online" });
    } else {
      return t("file.webCheckout");
    }
  };
  const renderNoSupprtExtPage = (): React.ReactNode => {
    return (
      <Box
        width={"100%"}
        height={"100%"}
        alignItems="center"
        justifyContent="center"
      >
        <Box
          direction="column"
          width={544}
          alignItems="center"
          justifyContent="center"
          height={"100%"}
        >
          <img
            src={require("../../shared/images/pages/File/emptyFilterDoc.png")}
            alt="no_content"
          />
          <Typography type={"h3"} lineHeight="24px" classes="mg mt-20">
            {t("login.link.noPreview")}
          </Typography>
          <Typography
            type="body2_rg"
            classes="mg mt-8"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("login.link.unSupprtExt")}
          </Typography>
          {docInfo?.documentInfo?.syncId && (
            <Button
              classes={"mg mt-20"}
              leadingIcon={<Icons variant={"line"} label={"download"} />}
              onClick={() =>
                handleDocDownload(
                  docInfo?.documentInfo?.syncId,
                  getContentDownload,
                  toast,
                  t
                )
              }
              btnStyle="fill"
              label={t("file.action.download")}
            />
          )}
        </Box>
      </Box>
    );
  };
  /** 웹 편집으로 이동 */
  const gotoEditMode = async (
    workgroupId: string,
    syncId: string
  ): Promise<void> => {
    const newSyncInfo = await docApi.getDocSyncInfo({ workgroupId, syncId });

    if (
      newSyncInfo?.status === "N" &&
      newSyncInfo?.authType === "R" &&
      newSyncInfo?.checkoutUser.userId === ""
    ) {
      const xFasooActionParam = {} as any;

      window.location.href.replace(
        /[?&]+([^=&]+)=([^&]*)/gi,
        function (m, key: string, value: string): any {
          xFasooActionParam[key] = decodeURIComponent(value);
        }
      );

      window.location.href = `/docs/preview?permission=edit&workgroupId=${xFasooActionParam["workgroupId"]}&syncId=${xFasooActionParam["syncId"]}&revisionNo=${newSyncInfo.revisionNo}&isClient=${isClient}&token=${xFasooActionParam["token"]}&redirectToken=${xFasooActionParam["redirectToken"]}`;
    } else {
      // await getSyncInfo({ workgroupId, syncId }); //TODO :  state setting

      if (newSyncInfo?.status === "T") {
        toast.toastMsg(nanoid(), t("file.alert.contentDelete"), "error");
      } else if (
        newSyncInfo?.authType === "V" ||
        newSyncInfo.authType !== "R"
      ) {
        toast.toastMsg(nanoid(), t("file.alert.checkoutFail"), "error");
      } else if (newSyncInfo?.checkoutUser.userId !== "") {
        toast.toastMsg(nanoid(), t("file.alert.checkoutAnotherUser"), "error");
      }
    }
    //권한 체크
  };
  /** UI: 미리보기 상단 헤더 */
  const renderPreviewHeader = () => {
    return (
      <Box classes="preview-header">
        {utilsDocs.renderDocIcon(docInfo?.documentInfo?.contentName, 48)}
        <Box classes="mg ml-8" direction="column" maxWidth={"calc(50% - 48px)"}>
          <Tooltip message={docInfo?.documentInfo?.contentName}>
            <Typography type="subtitle1" ellipsis>
              {docInfo?.documentInfo?.contentName}
            </Typography>
          </Tooltip>
          <Typography
            type="body2_rg"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {`${utilsDocs.fileSizeFormat(
              docInfo?.documentInfo?.fileSize
            )} • ${utilsDocs.fileFormattoStr(
              docInfo?.documentInfo?.contentName
            )}`}
          </Typography>
        </Box>
        {docInfo?.documentInfo?.myPolicy?.uniqueId !== "ONLYVIEW" && (
          <Box classes="mg ml-auto preview-header--actions">
            {checkIfDocRevision() && (
              <Button
                btnStyle="link"
                onClick={() =>
                  docInfo?.documentInfo &&
                  gotoEditMode(
                    docInfo?.documentInfo?.workgroup.workgroupId,
                    docInfo?.documentInfo?.syncId
                  )
                }
                label={
                  loginDto?.ecoCommonConfig.webOfficeType === "OFFICE365"
                    ? renderOfficeType()
                    : t("file.onlineOfficeCheckout", { office: "Web Office" })
                }
                leadingIcon={utilsDocs.renderDocIcon(
                  docInfo?.documentInfo?.contentName,
                  20,
                  loginDto?.ecoCommonConfig.webOfficeType === "OFFICE365"
                    ? "ms365"
                    : "collabora"
                )}
              />
            )}
            {docInfo &&
              !isClient &&
              utilsCommon.checkMenuAvailble(
                "download",
                docInfo?.documentInfo
              ) && (
                <Button
                  btnStyle="link"
                  label={t("file.action.download")}
                  onClick={() =>
                    handleDocDownload(
                      docInfo?.documentInfo?.syncId,
                      getContentDownload,
                      toast,
                      t,
                      docInfo?.documentInfo?.revisionNo + "",
                      docInfo?.documentInfo?.contentName
                    )
                  }
                  leadingIcon={<Icons variant="line" label="download" />}
                />
              )}
            {utilsCommon.checkMenuAvailble(
              "shareLink",
              docInfo?.documentInfo
            ) && (
              <Button
                btnStyle="link"
                label={t("file.action.copyLink")}
                leadingIcon={<Icons variant="line" label="link" />}
                onClick={() =>
                  docInfo?.documentInfo?.syncId &&
                  handleCopyLink(docInfo?.documentInfo?.syncId, toast)
                }
              />
            )}
            {!(
              docInfo?.documentInfo?.workgroup.workgroupId ===
                "NONEWORKGROUP" &&
              docInfo?.documentInfo?.master?.userId !== myId
            ) && (
              <Dropdown
                value={t("common.more")}
                btnStyle="link"
                placeholder=" "
                showValue
                leadingIcon={<Icons variant="line" label="moreVertical" />}
                iconPos={"left"}
                align="right"
              >
                {menus
                  .filter((item) =>
                    utilsCommon.checkMenuAvailble(
                      item.key,
                      docInfo?.documentInfo,
                      isClient ? "client_preview" : "preview"
                    )
                  )
                  .map((item) => (
                    <DropdownItem
                      height={item.key === "divider" ? undefined : 20}
                      type={item.key.includes("delete") ? "warning" : "default"}
                      state={item.key === "divider" ? "divider" : "default"}
                      label={item.resource}
                      frontIcon={item.icon}
                      onClick={item.onClick}
                    />
                  ))}
              </Dropdown>
            )}
          </Box>
        )}
      </Box>
    );
  };
  /** UI: 미리보기 상단 헤더 - 버튼들 */
  const renderPreviewRightButtons = () => {
    return (
      <Box classes="preview-right--btns">
        <Tooltip message={t("file.comment")}>
          <Button
            btnStyle="icon"
            classes="mg mb-8"
            leadingIcon={
              <Icons
                variant="fill"
                label="comment"
                stroke={activeBtnType === "comment" ? "#05C072" : undefined}
              />
            }
            onClick={() => changeActiveBtnType("comment")}
          />
        </Tooltip>
        <Tooltip message={t("file.detail")}>
          <Button
            btnStyle="icon"
            classes="mg mb-8"
            leadingIcon={
              <Icons
                variant="fill"
                label="detail"
                stroke={activeBtnType === "detail" ? "#05C072" : undefined}
              />
            }
            onClick={() => changeActiveBtnType("detail")}
          />
        </Tooltip>
        {utilsCommon.checkMenuAvailble(
          "aiChat",
          docInfo?.documentInfo,
          "preview"
        ) && (
          <Tooltip message="K-Assistant">
            <Button
              btnStyle="icon"
              leadingIcon={
                <Icons
                  variant="fill"
                  label="aiChat"
                  isOn={activeBtnType === "aiChat"}
                />
              }
              onClick={() => changeActiveBtnType("aiChat")}
            />
          </Tooltip>
        )}
        <Box classes="mg mt-auto" direction="column">
          <Tooltip
            message={t(
              activeBtnType === "CLOSE" ? "common.expand" : "common.collapse"
            )}
            classes="mg mt-auto"
          >
            <Button
              btnStyle="icon"
              onClick={() =>
                changeActiveBtnType(
                  activeBtnType === "CLOSE" ? "comment" : "CLOSE"
                )
              }
              leadingIcon={
                <Icons
                  variant="line"
                  label="sidebar"
                  isOn={activeBtnType === "CLOSE"}
                />
              }
            />
          </Tooltip>
        </Box>
      </Box>
    );
  };
  return docInfo ? (
    <Box width={"100%"} height={"100%"} classes={"preview"}>
      {modalType === "CHANGE_FILE_AUTH" &&
        (docInfo.documentInfo.workgroup.workgroupId === "NONEWORKGROUP" ? (
          <ChangeFileAuthModal
            open={modalType === "CHANGE_FILE_AUTH"}
            onClose={() => changeModalType("CLOSE")}
            docInfo={docInfo.documentInfo}
            onClickAfterSubmit={checkPermissionByDetail}
          />
        ) : (
          <ChangeWorkgroupFileAuthModal
            open={modalType === "CHANGE_FILE_AUTH"}
            onClose={() => changeModalType("CLOSE")}
            docInfos={[docInfo.documentInfo]}
            onClickAfterSubmit={checkPermissionByDetail}
          />
        ))}
      {modalType === "CONFIRM_DELETE" && (
        <Modal
          title={t("common.delete")}
          width={530}
          bodyMsg={t("file.alert.deleteLetClose")}
          open={modalType === "CONFIRM_DELETE"}
          onClose={() => changeModalType("CLOSE")}
          footer={
            <Box>
              <Button
                btnStyle="fill"
                type="secondary"
                label={t("common.cancel")}
                onClick={() => changeModalType("CLOSE")}
              />
              <Button
                btnStyle="fill"
                type="error"
                label={t("common.delete")}
                onClick={() =>
                  docInfo?.documentInfo &&
                  doDeleteDocument(
                    [docInfo?.documentInfo],
                    toast,
                    getDocDelete,
                    () => {
                      window.close();
                      window.opener.location.reload();
                    }
                  )
                }
              />
            </Box>
          }
        />
      )}
      {renderPreviewHeader()}
      <Box classes="preview-body">
        <Box classes="preview-iframe">
          {loginDto?.ecoCommonConfig.watermark === "ALL" &&
            window.eco.companyName !== "workspace" && (
              <div
                className={"preview__wtmkStyle"}
                style={{
                  top: (loginDto?.ecoCommonConfig.watermarkTop ?? 59) + "%",
                  fontSize:
                    (loginDto?.ecoCommonConfig.watermarkFontSize ?? 16) + "pt",
                  opacity: loginDto?.ecoCommonConfig.watermarkOpacity ?? 0.2,
                  transform:
                    "rotate(" +
                    (loginDto?.ecoCommonConfig.watermarkRotate ?? -30) +
                    "deg)",
                }}
              >
                {loginDto?.userInfo && accessUrl ? screenWatermark : ""}
              </div>
            )}
          {accessUrl ? (
            <IframeComm
              attributes={{
                src: accessUrl,
                width: "100%",
                height: "100%",
                id: "office",
                sandbox:
                  "allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation allow-popups-to-escape-sandbox",
                display: "block",
                allowFullscreen: "true",
                position: "relative",
              }}
            />
          ) : (
            renderNoSupprtExtPage()
          )}
        </Box>
        <Box classes="preview-right">
          {renderPreviewRightButtons()}
          {activeBtnType !== "CLOSE" && (
            <PreviewAside docInfo={docInfo} activeBtnType={activeBtnType} />
          )}
        </Box>
      </Box>
    </Box>
  ) : (
    <Box width={"100%"} height={"100%"} classes={"preview"}></Box>
  );
};

export default Preview;
